// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareOutlinedSvg from "@ant-design/icons-svg/es/asn/CloseSquareOutlined";
import AntdIcon from '../components/AntdIcon';

var CloseSquareOutlined = function CloseSquareOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareOutlinedSvg
  }));
};

CloseSquareOutlined.displayName = 'CloseSquareOutlined';
export default React.forwardRef(CloseSquareOutlined);